import { Col, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Form from "../../form-components/from";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";

import CharityContext from "../../../context/charity/context";
import EndPoints from "../../../services/end-points";

interface IProps { }

const CharityFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(CharityContext);

  const [categories, setCategories] = useState<any[]>([]);
  const [badges, setBadges] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [loadingBadges, setLoadingBadges] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);

  // Load data on mount
  useEffect(() => {
    const fetchData = async () => {
      // Fetch categories
      setLoadingCategories(true);
      try {
        const res = await EndPoints.categoryCharity.getAllCategoriesCharities({
          light: true,
          perPage: -1,
        });
        setCategories(
          res.data.data.map((item: any) => ({
            label: item.name,
            value: item.id,
          }))
        );
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoadingCategories(false);
      }

      // Fetch badges
      setLoadingBadges(true);
      try {
        const res = await EndPoints.badgeCharity.getAllBadgeCharities({
          light: true,
          perPage: -1,
        });
        setBadges(
          res.data.data.map((item: any) => ({
            label: item.name,
            value: item.id,
          }))
        );
      } catch (error) {
        console.error("Error fetching badges:", error);
      } finally {
        setLoadingBadges(false);
      }

      // Fetch cities
      setLoadingCities(true);
      try {
        const res = await EndPoints.city.getAllCities({ light: true, perPage: -1 });
        setCities(
          res.data.data.map((item: any) => ({
            label: item.name,
            value: item.id,
          }))
        );
      } catch (error) {
        console.error("Error fetching cities:", error);
      } finally {
        setLoadingCities(false);
      }
    };

    fetchData();
  }, []);

  return (
    <Form
      formId="charity-filter"
      onSubmit={(data) => {
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: data?.keyword,
          filters: [
            data?.categoryCharity
              ? {
                name: "category_charity_id",
                value: data.categoryCharity,
                operation: "eq",
              }
              : undefined,
            data?.badge
              ? {
                name: "badge_id",
                value: data.badge,
                operation: "eq",
              }
              : undefined,
            data?.status !== undefined && data.status !== null
              ? {
                name: "status",
                value: data.status,
                operation: "eq",
              }
              : undefined,
            data?.city
              ? {
                name: "city_id",
                value: data.city,
                operation: "eq",
              }
              : undefined,
          ].filter(Boolean),
        };
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        {/* Category */}
        <Col span={8}>
          <FieldBuilder
            name="categoryCharity"
            label={t("category")}
            width="large"
            input={{
              type: "select",
              options: categories,
              loading: loadingCategories,
              allowSearch:true
            }}
          />
        </Col>

        {/* Badge */}
        <Col span={8}>
          <FieldBuilder
            name="badge"
            label={t("badge")}
            width="large"
            input={{
              type: "select",
              options: badges,
              loading: loadingBadges,
              allowSearch: true

            }}
          />
        </Col>

        {/* Status */}
        <Col span={8}>
          <FieldBuilder
            name="status"
            label={t("status")}
            width="large"
            input={{
              type: "select",
              options: [
                { label: t("active"), value: 1 },
                { label: t("inactive"), value: 2 },
              ],

            }}
          />
        </Col>

        {/* City */}
        <Col span={8}>
          <FieldBuilder
            name="city"
            label={t("city")}
            width="large"
            input={{
              type: "select",
              options: cities,
              loading: loadingCities,
              allowSearch: true
            }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default CharityFilter;